module.exports = __webpack_public_path__ + "img/SCCY1.25368242.jpg";